<script>
  export let textColor
</script>

<style>
  .kb-logo__wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin: 0 0 20px 0;
    padding-right: 14px;
  }

  .kb-logo__icon {
    content: url('https://statisc2test.kudobuzz.com/icons/kudobuzz-logo-default.svg');
    width: 50%;
    height: 50%;
    margin-top: 3px;
  }

  .kb-logo__label {
    color: #000533;
    width: 100%;
    display: block;
    text-align: right;
    font-size: 12px;
    margin-bottom: -5px;
    box-sizing: border-box;
  }

  @media only screen and (max-width: 340px) {
    .kb-logo__wrapper {
      width: 120px;
    }
  }
</style>

<div class="kb-logo__wrapper">
  <span style="color: {textColor};" class="kb-logo__label">Powered by</span>
  <div class="kb-logo__icon" />
</div>
